import tagTester from './_tagTester.js';

export default tagTester('RegExp');



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/isRegExp.js
// module id = null
// module chunks = 